__turbopack_context__.v({
  "blue": "Step-module-scss-module__px6pMq__blue",
  "container": "Step-module-scss-module__px6pMq__container",
  "green": "Step-module-scss-module__px6pMq__green",
  "number": "Step-module-scss-module__px6pMq__number",
  "pink": "Step-module-scss-module__px6pMq__pink",
  "stepWrapper": "Step-module-scss-module__px6pMq__stepWrapper",
  "text": "Step-module-scss-module__px6pMq__text",
  "textWrapper": "Step-module-scss-module__px6pMq__textWrapper",
  "title": "Step-module-scss-module__px6pMq__title",
  "wrapper": "Step-module-scss-module__px6pMq__wrapper",
});
